export enum PaymentMethod {
  Cash = 'CASH',
  EDC = 'EDC',
  Transfer = 'TRANSFER',
  Wallet = 'WALLET',
  Other = 'OTHER',
  Split = 'SPLIT',
}
